






































import Vue from "vue";

export default Vue.extend({
  name: "UserImage",

  data: () => ({
    edit: false,
    deleting: false,
    comment: ""
  }),

  props: {
    file: {}
  },
  mounted() {
    this.comment = this.$props.file.comment;
  },

  methods: {
    async saveFile(event: Event) {
      if (this.deleting) {
        return;
      }
      await this.$store.dispatch("files/updateFile", {
        id: this.$props.file.id,
        comment: this.comment
      });
      this.edit = false;
    },
    async deleteFile(event: Event) {
      if (this.deleting || this.edit) {
        return;
      }
      if (await this.$confirm("Are you sure?")) {
        this.deleting = true;
        try {
          await this.$store.dispatch("files/deleteFile", this.$props.file);
        } catch (e) {
          console.error(e);
          this.deleting = false;
        }
      }
    }
  }
});
